import React from 'react';
import PageContainer from "../../../../hoc/PageContainer";

const DistrictMentorshipProgram = () => (
    <div>
        <PageContainer page="ourServices">
            <h1 className="AboutUsTitle">Rotary Club of Central - Year 2015-2016 : District Mentorship Program</h1>

            <div className="our-services-video-container">
                <iframe width="854" height="480" src="https://www.youtube.com/embed/tMHw-cuLO70" frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/></div>

            <div className="AboutUsText">
                The objectives of District 3450 Mentorship Programme were to build leadership skills, enhance self-confidence, particularly for mentees, enhance mentoring and coaching skills for mentors, gain insights to tackle challenges in future workplace, and build a strong and supportive network. Mentors and mentees are matched according to profession, interests and motivations. A series of events were organised e.g. Inspiring talks and panel discussion, skills workshops, mentoring circles, informal social and networking events, etc.
            </div>
        </PageContainer>
    </div>
);

export default DistrictMentorshipProgram;
